import { ADD_TO_CART, REMOVE_FROM_CART, INCREASE_CART_QTY, DECREASE_CART_QTY } from "./actionTypes";
import initialState from "./initialState";

const cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_TO_CART:
            const item = state.find(p => p.id === action.payload);
            if (item === undefined) {
                return [...state, { id: action.payload, quantity: 1 }];
            }

            const others = state.filter(p => p.id !== action.payload);
            return [...others, {...item, quantity: item.quantity + 1} ];
            
        case REMOVE_FROM_CART: 
            const filteredItems = state.filter(p => p.id !== action.payload);
            return filteredItems;

        case INCREASE_CART_QTY:
            const itemToIncreaseQty = state.find(p => p.id === action.payload);
            if (itemToIncreaseQty !== undefined) {
                const others = state.filter(p => p.id !== action.payload);
                return [...others, {...itemToIncreaseQty, quantity: itemToIncreaseQty.quantity + 1}]
            }
            return;

        case DECREASE_CART_QTY:
            const itemToDecreaseQty = state.find(p => p.id === action.payload);
            if (itemToDecreaseQty !== undefined) {
                const others = state.filter(p => p.id !== action.payload);
                return [...others, {...itemToDecreaseQty, quantity: itemToDecreaseQty.quantity - 1}]
            }
            return;

        default:
            return state;
    }
}

export default cartReducer;